var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-button',{attrs:{"variant":"warning"},on:{"click":function($event){$event.stopPropagation();return _vm.exportar()}}},[_c('i',{staticClass:"fa fa-file-excel-o mr-2"}),_vm._v(" Exportar\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }